import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';



export function shopping() {
    let carousels = document.querySelectorAll('[data-shoppingCarousel]');

    carousels.forEach(carousel => {
        const swiper = new Swiper(carousel, {
            modules: [Mousewheel],
            slidesPerView: 1.5,
            spaceBetween: 0,
            grabCursor: true,
            mousewheel: true,
        });
    })

}
